<template>
  <div>
    <avue-crud :table-loading="list.loading" :option="option" :data="list.data" ref="crud"
      @refresh-change="refreshChange">
      <!-- 自定义搜索框 -->
      <template slot="mySearch">
        <Search />
      </template>
      <!-- 自定义表格列 -->
      <template #channelId="{ row }">
        <span>{{ `[${row.channelId}] ${row.channelName}` }}</span>
      </template>
      <!-- 自定义表格操作栏 -->
      <template #menu="{ row }">
        <el-button v-auth="'SECURITY_CHANNEL_CONFIG_EDIT'" type="text" size="small" @click="edit(row)">
          编辑
        </el-button>
        <el-button v-auth="'SECURITY_CHANNEL_CONFIG_DEL'" type="text" size="small" @click="del(row.id)">
          删除
        </el-button>
      </template>
    </avue-crud>
    <!-- 分页组件 -->
    <ElementPagination style="margin-bottom: 20px" :current-page="searchParams.current" :page-size="searchParams.size"
      :total="searchParams.total" :page-sizes="[10, 20, 30, 40, 50]" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :disabled="list.disabled" />
    <!-- 新增/编辑 对话框 -->
    <Add ref="add" />
  </div>

</template>

<script>
import Search from './search.vue'
import Add from './add.vue'
// import { formatEditData } from '../utils/index'
import { deleteChannelConfig } from '@/api/security/channelConfig'
import Message from '@/components/Message'
import ElementPagination from "@/components/ElementPagination";
export default {
  name: 'WebSaaSTable',
  inject: ['searchParams', 'list', 'loadList'],
  components: {
    Search,
    Add,
    ElementPagination
  },

  data() {
    return {
      /** avue配置 */
      option: {
        lazy: true,
        tip: false,
        simplePage: true,
        searchShow: true,
        // searchMenuSpan: 6,
        tree: true,
        border: true,
        /** 表格索引 */
        index: false,
        /** 表格搜索显隐按钮 */
        searchShowBtn: true,
        /** 是否启用功能按钮 */
        searchIcon: true,
        searchIndex: 0,
        /** 表格查看按钮 */
        viewBtn: false,
        /** 表格新增按钮 */
        addBtn: false,
        /** 表格删除按钮 */
        delBtn: false,
        /** 表格修改按钮 */
        editBtn: false,
        /** 导出按钮 */
        excelBtn: false,
        /** 是否有选择框	 */
        selection: false,
        /** 表格高度 */
        // height: 500,
        /** 是否有操作栏 */
        menu: true,
        /** 操作栏宽度 */
        menuWidth: 120,
        // menuFixed: true,
        column: [
          {
            label: "ID",
            prop: "id"
          },
          {
            label: "渠道",
            prop: "channelId",
            slot: true
          },
          {
            label: "端类型",
            prop: "clientType",
            dicData: [
              { label: "发端", value: "1" },
              { label: "收端", value: "2" }
            ]
          },
          {
            label: "云桌面检测配置",
            prop: "cloudDeskFlag",
            width: "120",
            dicData: [
              { label: "关闭", value: "0" },
              { label: "开启", value: "1" }
            ]
          },
          {
            label: "云镜像检测配置",
            prop: "cloudMirrorFlag",
            width: "120",
            dicData: [
              { label: "关闭", value: "0" },
              { label: "开启", value: "1" }
            ]
          },
          {
            label: "好友分享检测配置",
            prop: "friendShareFlag",
            width: "120",
            dicData: [
              { label: "关闭", value: "0" },
              { label: "开启", value: "1" }
            ]
          },
          {
            label: "局域网镜像检测配置",
            prop: "lanMirrorFlag",
            width: "130",
            dicData: [
              { label: "关闭", value: "0" },
              { label: "开启", value: "1" }
            ]
          },
          {
            label: "本地音频检测配置",
            prop: "localAudioFlag",
            width: "120",
            dicData: [
              { label: "关闭", value: "0" },
              { label: "开启", value: "1" }
            ]
          },
          {
            label: "本地图片检测配置",
            prop: "localPicFlag",
            width: "120",
            dicData: [
              { label: "关闭", value: "0" },
              { label: "开启", value: "1" }
            ]
          },
          {
            label: "本地视频检测配置",
            prop: "localVideoFlag",
            width: "120",
            dicData: [
              { label: "关闭", value: "0" },
              { label: "开启", value: "1" }
            ]
          },
          {
            label: "在线音频检测配置",
            prop: "onlineAudioFlag",
            width: "120",
            dicData: [
              { label: "关闭", value: "0" },
              { label: "开启", value: "1" }
            ]
          },
          {
            label: "在线图片检测配置",
            prop: "onlinePicFlag",
            width: "120",
            dicData: [
              { label: "关闭", value: "0" },
              { label: "开启", value: "1" }
            ]
          },
          {
            label: "在线视频域名策略",
            prop: "onlineVideoDomainStrategy",
            width: "120",
          },
          {
            label: "在线视频检测配置",
            prop: "onlineVideoFlag",
            width: "120",
            dicData: [
              { label: "关闭", value: "0" },
              { label: "开启", value: "1" }
            ]
          },
          {
            label: "备注",
            prop: "remark"
          },
          {
            label: "创建人",
            prop: "createBy"
          },
          {
            label: "创建时间",
            prop: "createTime"
          },
          {
            label: "修改人",
            prop: "updateBy"
          },
          {
            label: "更新时间",
            prop: "updateTime"
          },
          {
            label: "",
            prop: "my",
            hide: true,
            showColumn: false,
            search: true,
            display: false,
            menuClassName: "myClass",
            searchslot: true,
          },
        ],
      },
    };
  },


  methods: {
    /** 编辑 */
    edit(row) {
      console.log("🚀 ~ edit ~ row:", row)
      this.$refs.add.show('edit', row);
    },
    /** 删除 */
    del(id) {
      this.$confirm('是否删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data } = await deleteChannelConfig(id);
        if (data.code === 200) {
          Message.success('删除成功')
          this.loadList();
        }
      }).catch(() => {
        console.log("🚀 ~ del ~ 已取消删除")
      });

    },
    //^ ^--------------分页相关-------------^ ^
    /** avue的刷新 */
    refreshChange() {
      this.loadList();
    },
    /** 每页条数change */
    handleSizeChange(val) {
      this.searchParams.size = val;
      Message.success(`每页 ${val} 条`);
      /** 更新数据 */
      this.loadList();
    },
    /** 当前页change */
    handleCurrentChange(val) {
      this.searchParams.current = val;
      Message.success(`当前页 ${val}`);
      /** 更新数据 */
      this.loadList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../.././styles/avue-crud-normal.scss";
</style>
